
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ApiUrl from "./../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext"; // Import useToast hook
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


function DailyRates() {
  const navigate = useNavigate();
  const toast = useToast(); // Use the toast hook

  const handleUpdateDailyRates = (id) => {
    navigate(`/update-daily-rates/${id}`);
  };

  // get method
  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchData();
  }, []);

const fetchData = async () => {
  try {
    setIsLoading(true);
    const response = await axios.get(`${ApiUrl}/Api/daily_rates.php`);

    if (response.data && response.data.data) {
      const reversedData = response.data.data.reverse(); // Reverse the array
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      setResponseData(reversedData);
      // toast.success("Data loaded successfully", 3000, "topRight");
    } else {
      setResponseData([]);
      setError("No Data Found");
      // toast.info("No data available", 3000, "topRight");
    }
  } catch (error) {
    console.log("error", error.message);
    setError("Failed to fetch data. Please try again later.");
    setResponseData([]);
    toast.error("Failed to fetch data", 3000, "topRight");
  }
};


  // Function to format time to 12-hour format with AM/PM
  const formatTo12Hour = (timeString) => {
    if (!timeString) return "";

    try {
      // Create a date object using the time string
      const date = new Date(`1970-01-01T${timeString}`);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        throw new Error("Invalid date");
      }

      // Format using the date object's methods
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      // If there's an error parsing the date, try a manual approach
      // Assuming timeString is in 24-hour format (HH:MM:SS or HH:MM)
      const parts = timeString.split(":");
      if (parts.length >= 2) {
        let hour = parseInt(parts[0], 10);
        const minutes = parts[1];
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12; // Convert 0 to 12
        return `${hour}:${minutes} ${ampm}`;
      }
      return timeString; // Return original if parsing fails
    }
  };

  // delete method
  const [deleteShowModals, setDeleteShowModals] = useState(false); // Delete modal
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  // Delete confirmation modal
  const handleOpenModal = (id, gold_1g_rate) => {
    setdeleteid(id);
    setdeletename(gold_1g_rate);
    setDeleteShowModals(true);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const handleDelete = async () => {
    // toast.warning("Operation in progress", 2000, "topCenter");
    try {
      await axios.delete(`${ApiUrl}/Api/daily_rates.php/${getdeleteid}`);
      toast.success("Deleted successfully!", 3000, "topRight");
      setDeleteShowModals(false);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete the record", 3000, "topRight");
    }
  };

  // pagination and search start

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Filter data based on search term
  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.type && item.type.toLowerCase().includes(searchLower)) ||
      (item.date && item.date.toLowerCase().includes(searchLower)) ||
      (item.gold_1g_rate &&
        item.gold_1g_rate.toString().includes(searchLower)) ||
      (item.silver_10g_rate &&
        item.silver_10g_rate.toString().includes(searchLower))
    );
  });

  // Calculate pagination values
  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

  // Get current items for pagination
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

  // Pagination handlers
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1); // Reset to first page when changing items per page
    }
  };

  // Render pagination buttons
  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // First page and ellipsis
    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    // Visible page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    // Last page and ellipsis
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };




  // Export Functions
  const handlePrint = () => {
    const printContent = generatePrintContent();
    const printWindow = window.open("", "_blank");
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    toast.success("Print dialog opened", 2000, "topRight");
  };

  const generatePrintContent = () => {
    const currentDate = new Date().toLocaleDateString();
    let printHTML = `
      <html>
        <head>
          <title>Daily Rates Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 20px; }
            .date { text-align: right; margin-bottom: 10px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .currency { color: #28a745; font-weight: bold; }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>Daily Rates Report</h2>
            <div class="date">Generated on: ${currentDate}</div>
          </div>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Gold Rate (₹)</th>
                <th>Silver Rate (₹)</th>
                <th>Last Update</th>
              </tr>
            </thead>
            <tbody>
    `;

    filteredData.forEach((item, index) => {
      printHTML += `
        <tr>
          <td>${index + 1}</td>
          <td>${item.date}</td>
          <td class="currency">₹${item.gold_1g_rate}</td>
          <td class="currency">₹${item.silver_10g_rate}</td>
          <td>${formatTo12Hour(item.time)}</td>
        </tr>
      `;
    });

    printHTML += `
            </tbody>
          </table>
          <div style="margin-top: 20px; text-align: center; font-size: 12px; color: #666;">
            Total Records: ${filteredData.length}
          </div>
        </body>
      </html>
    `;

    return printHTML;
  };

  const exportDailyRatePDF = () => {
    try {
      const doc = new jsPDF();

      // Add title
      doc.setFontSize(18);
      doc.setTextColor(40, 40, 40);
      doc.text("Daily Rates Report", 14, 22);

      // Add generation info
      const now = new Date();
      doc.setFontSize(11);
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Generated on: ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`,
        14,
        32
      );
      doc.text(`Total Records: ${filteredData.length}`, 14, 40);

      // Define headers for daily rates
      const tableColumn = [
        "S.No",
        "Date",
        "Gold Rate (₹)",
        "Silver Rate (₹)",
        "Last Update",
      ];
      const tableRows = filteredData.map((item, index) => [
        index + 1,
        item.date || "",
        `₹${item.gold_1g_rate || ""}`,
        `₹${item.silver_10g_rate || ""}`,
        formatTo12Hour(item.time || ""),
      ]);

      // Render table
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 50,
        styles: {
          fontSize: 9,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        margin: { top: 50, left: 14, right: 14 },
      });

      // Save file
      doc.save(`Daily_Rates_Report_${now.toISOString().split("T")[0]}.pdf`);
      toast.success("Daily Rates PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error generating Daily Rates PDF:", error);
      toast.error("Failed to export Daily Rates PDF", 3000, "topRight");
    }
  };

  // Helper to format time in 12-hour format
  // const formatTo12Hour = (timeStr) => {
  //   if (!timeStr) return '';
  //   const [hour, minute] = timeStr.split(':');
  //   const h = parseInt(hour);
  //   const ampm = h >= 12 ? 'PM' : 'AM';
  //   const hour12 = h % 12 || 12;
  //   return `${hour12}:${minute} ${ampm}`;
  // };

  const handleCopy = () => {
    try {
      const headers = [
        "S.No",
        "Date",
        "Gold Rate (₹)",
        "Silver Rate (₹)",
        "Last Update",
      ];
      const rows = (filteredData || []).map((item, index) => [
        index + 1,
        item?.date || "",
        `₹${item?.gold_1g_rate || ""}`,
        `₹${item?.silver_10g_rate || ""}`,
        formatTo12Hour(item?.time || ""),
      ]);

      let copyText = "Daily Rates Report\n";
      copyText += "Generated on: " + new Date().toLocaleDateString() + "\n\n";
      copyText += [headers, ...rows].map((row) => row.join("\t")).join("\n");
      copyText += `\n\nTotal Records: ${filteredData?.length || 0}`;

      // Try modern Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(copyText)
          .then(() => {
            toast.success("Data copied to clipboard!", 3000, "topRight");
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(copyText);
          });
      } else {
        // Clipboard API not supported
        fallbackCopy(copyText);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  // ✅ Fallback method using a hidden textarea
  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;

      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = "0";
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        toast.success("Data copied using fallback!", 3000, "topRight");
      } else {
        throw new Error("Fallback copy failed");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const handleCSV = () => {
    try {
      const csvContent = generateCSV();
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `daily_rates_${new Date().toISOString().split("T")[0]}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV file downloaded successfully!", 2000, "topRight");
    } catch (error) {
      console.error("CSV export error:", error);
      toast.error("Failed to export CSV", 2000, "topRight");
    }
  };

  const generateCSV = () => {
    const headers = [
      "S.No",
      "Date",
      "Gold Rate (₹)",
      "Silver Rate (₹)",
      "Last Update",
    ];
    const csvRows = [];

    // Add headers
    csvRows.push(headers.join(","));

    // Add data rows
    filteredData.forEach((item, index) => {
      const row = [
        index + 1,
        `"${item.date}"`,
        `"₹${item.gold_1g_rate}"`,
        `"₹${item.silver_10g_rate}"`,
        `"${formatTo12Hour(item.time)}"`,
      ];
      csvRows.push(row.join(","));
    });

    return csvRows.join("\n");
  };

  const handleExcel = () => {
    try {
      const excelContent = generateExcelContent();
      const blob = new Blob([excelContent], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `daily_rates_${new Date().toISOString().split("T")[0]}.xls`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("Excel file downloaded successfully!", 2000, "topRight");
    } catch (error) {
      console.error("Excel export error:", error);
      toast.error("Failed to export Excel", 2000, "topRight");
    }
  };

  const generateExcelContent = () => {
    let excelContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="utf-8">
          <meta name="ProgId" content="Excel.Sheet">
          <meta name="Generator" content="Microsoft Excel 15">
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .currency { color: #28a745; }
          </style>
        </head>
        <body>
          <table>
            <tr>
              <th colspan="5" style="text-align: center; font-size: 16px; font-weight: bold;">Daily Rates Report</th>
            </tr>
            <tr>
              <th colspan="5" style="text-align: center;">Generated on: ${new Date().toLocaleDateString()}</th>
            </tr>
            <tr></tr>
            <tr>
              <th>S.No</th>
              <th>Date</th>
              <th>Gold Rate (₹)</th>
              <th>Silver Rate (₹)</th>
              <th>Last Update</th>
            </tr>
    `;

    filteredData.forEach((item, index) => {
      excelContent += `
        <tr>
          <td>${index + 1}</td>
          <td>${item.date}</td>
          <td class="currency">₹${item.gold_1g_rate}</td>
          <td class="currency">₹${item.silver_10g_rate}</td>
          <td>${formatTo12Hour(item.time)}</td>
        </tr>
      `;
    });

    excelContent += `
            <tr></tr>
            <tr>
              <td colspan="5" style="text-align: center; font-weight: bold;">Total Records: ${filteredData.length}</td>
            </tr>
          </table>
        </body>
      </html>
    `;

    return excelContent;
  };





  return (
    <>
      {/* {isLoading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )} */}

      <div className="container-fluid py-1">
        {/* Add Customer Button */}
        <div className="d-flex mb-3">
          <h6 className="card-title m-2">Daily Rates</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={() => {
              navigate("/add-daily-rates");
            }}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>

        {/* Customer List Card */}
        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              {/* Left side - Show per page */}
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Center - Export/Action buttons */}

              {/* Center - Export/Action buttons */}
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                  title="Print Table"
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportDailyRatePDF}
                  title="Export as PDF"
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handleCopy}
                  title="Copy to Clipboard"
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handleCSV}
                  title="Export as CSV"
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handleExcel}
                  title="Export as Excel"
                >
                  Excel
                </button>
              </div>

              {/* Right side - Search */}
              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1); // Reset to first page when searching
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Table with responsive wrapper */}
            <div className="card tableCard p-2">
              {isLoading ? (
                <div className="text-center p-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : error ? (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="bg-light">
                      <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        <th>Gold Rate</th>
                        <th>Silver Rate</th>
                        <th>Last Update</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        // Display filtered data based on pagination
                        currentItems.map((item, index) => (
                          <tr key={item.id || index}>
                            <td>
                              {showAllItems
                                ? index + 1
                                : (currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>{item.date}</td>
                            <td>
                              <span className="mx-1">₹</span>
                              {item.gold_1g_rate}
                            </td>
                            <td>
                              <span className="mx-1">₹</span>
                              {item.silver_10g_rate}
                            </td>
                            <td>{formatTo12Hour(item.time)}</td>
                            <td className="">
                              <button
                                className="btn btn-sm btn-light me-2"
                                onClick={() => {
                                  handleUpdateDailyRates(item.id);
                                }}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={() =>
                                  handleOpenModal(item.id, item.gold_1g_rate)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {!isLoading && !error && filteredData.length > 0 && (
                <div className="row">
                  <div className="col-lg-6">
                    <p className="text-muted">
                      Showing{" "}
                      {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1}{" "}
                      to{" "}
                      {showAllItems
                        ? totalItems
                        : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                      of {totalItems} entries
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <nav aria-label="Page navigation">
                      <ul className="pagination justify-content-end">
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(1)}
                            aria-label="First"
                          >
                            <span aria-hidden="true">&laquo;&laquo;</span>
                          </button>
                        </li>
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                            aria-label="Previous"
                          >
                            <span aria-hidden="true">&laquo;</span>
                          </button>
                        </li>

                        {renderPageNumbers()}

                        <li
                          className={`page-item ${currentPage === totalPages || totalPages === 0
                              ? "disabled"
                              : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                            aria-label="Next"
                          >
                            <span aria-hidden="true">&raquo;</span>
                          </button>
                        </li>
                        <li
                          className={`page-item ${currentPage === totalPages || totalPages === 0
                              ? "disabled"
                              : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(totalPages)}
                            aria-label="Last"
                          >
                            <span aria-hidden="true">&raquo;&raquo;</span>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Delete Modal - Using Bootstrap Modal with state control */}
        {deleteShowModals && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
            aria-labelledby="deleteConfirmModalLabel"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-confirm">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <div className="d-flex justify-content-center mb-3">
                    <div
                      className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                      style={{
                        width: "80px",
                        height: "80px",
                        margin: "0 auto",
                      }}
                    >
                      <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                    </div>
                  </div>

                  <h4 className="modal-title mb-3 text-center">
                    Are you sure?
                  </h4>
                  <h6 className="mb-4 text-center">
                    Do you really want to delete this gold rate{" "}
                    <span className="text-primary">({getdeletename}</span>
                    )? This action cannot be undone.
                  </h6>

                  <div className="d-flex btn-group">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm flex-grow-1"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm flex-grow-1 mx-2"
                      onClick={handleDelete}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DailyRates;
